export const GET_PAID_CUSTOMERS = "GET_PAID_CUSTOMERS";